import { useGetCurrentSignupList } from "Utilities/Hooks/useGetCurrentSignupList";
import SignupOption from "../SignupOption";

export default function MultipleItems() {
  const {
    options: { allowMultipleItemSignups },
    signupListStatusID,
  } = useGetCurrentSignupList();

  return (
    <SignupOption
      text="Allow people to sign up for multiple items"
      name="allowMultipleItemSignups"
      on={allowMultipleItemSignups > 0}
      disabled={signupListStatusID !== 1}
    />
  );
}
